import select from './select';

const on = (elements, event, callback) => {
    const events = event.split(' ').filter((e) => e !== '');
    select(elements).forEach((element) => {
        events.forEach((eventName) => {
            element.addEventListener(eventName, callback);
        });
    });
};

export default on;
